(function() {
  const BUNDLE_MAP = {
    '46565958353058': { code: 'WQ-BDL-HL2-SHELTER', name: 'Horizon Lite 2 Shelter Bundle', sku: 'WQ-BDL-HL2-FP-20', pair: '46565069258914' },
    '46565069258914': { code: 'WQ-BDL-HL2-SHELTER', name: 'Horizon Lite 2 Shelter Bundle', sku: 'WQ-BDL-HL2-FP-20', pair: '46565958353058' },
    '46565068800162': { code: 'WQ-BDL-GL2-SHELTER', name: 'Gale Lite 2 Shelter Bundle', sku: 'WQ-BDL-GL2-FP-20', pair: '46565069357218' },
    '46565069357218': { code: 'WQ-BDL-GL2-SHELTER', name: 'Gale Lite 2 Shelter Bundle', sku: 'WQ-BDL-GL2-FP-20', pair: '46565068800162' },
    '46565160288418': { code: 'WQ-BDL-HX-SLEEPKIT', name: 'Horizon X Ultralight Sleep Kit', sku: 'WQ-BDL-HX-PUMP-10', pair: '46565160353954' },
    '46565069422754': { code: 'WQ-BDL-EX-SLEEPKIT', name: 'Elevate X Air Sleep Kit', sku: 'WQ-BDL-EX-PUMP-10', pair: '46565160353954' },
  };

  const AEROX_PUMP_ID = '46565160353954';
  const AEROX_PUMP_PAIR_MAP = {
    '46565160288418': { code: 'WQ-BDL-HX-SLEEPKIT', name: 'Horizon X Ultralight Sleep Kit', sku: 'WQ-BDL-HX-PUMP-10' },
    '46565069422754': { code: 'WQ-BDL-EX-SLEEPKIT', name: 'Elevate X Air Sleep Kit', sku: 'WQ-BDL-EX-PUMP-10' },
  };

  function injectBundleProperties(items) {
    const variantIds = items.map(item => String(item.id));

    return items.map(item => {
      const vid = String(item.id);
      let bundleInfo = null;

      if (vid === AEROX_PUMP_ID) {
        for (const [pairId, info] of Object.entries(AEROX_PUMP_PAIR_MAP)) {
          if (variantIds.includes(pairId)) { bundleInfo = info; break; }
        }
      } else if (BUNDLE_MAP[vid] && variantIds.includes(BUNDLE_MAP[vid].pair)) {
        const m = BUNDLE_MAP[vid];
        bundleInfo = { code: m.code, name: m.name, sku: m.sku };
      }

      if (bundleInfo) {
        item.properties = item.properties || {};
        item.properties['_bundle_code'] = bundleInfo.code;
        item.properties['_bundle_name'] = bundleInfo.name;
        item.properties['_bundle_parent_sku'] = bundleInfo.sku;
      }

      return item;
    });
  }

  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
      try {
        const body = JSON.parse(options.body);
        if (body.items && Array.isArray(body.items)) {
          body.items = injectBundleProperties(body.items);
          options.body = JSON.stringify(body);
        }
      } catch(e) {}
    }
    return originalFetch.apply(this, arguments);
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._wqUrl = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._wqUrl && this._wqUrl.includes('/cart/add') && body) {
      try {
        const parsed = JSON.parse(body);
        if (parsed.items && Array.isArray(parsed.items)) {
          parsed.items = injectBundleProperties(parsed.items);
          body = JSON.stringify(parsed);
        }
      } catch(e) {}
    }
    return originalSend.call(this, body);
  };
})();
